<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    class="vcita-button"
    :color="brandBackground ? brandBgColor : ''"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
  export default {
    name: 'vcitaButton',
    props: {
      brandBackground: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      brandBgColor() {
        return this.$store && this.$store.getters['brandModule/secondaryColor'];
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_i18n-mixins";
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
  .vcita-button {
    min-height: 52px;
    color: #ffffff;
    font-size: 17px;
    @include md-and-up {
      min-height: unset;
      font-size: 13px;
    }
    ::v-deep {
      span {
        text-transform: none;
      }
    }
  }
</style>
